
<template>
  <!--新增小区-->
  <div>
  <x-addEdit
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
    <template slot="gps" slot-scope="{formItem}">
      <x-location
        :form="$children[0].form"
        :inputKey="inputKey"
        :position="position"
        :locationData="formItem">
      </x-location>
    </template>
  </x-addEdit>

  </div>
</template>
<script>
import mixin from '../../../js/mixins';
export default {
  mixins: [mixin.addEdit, mixin.fetchSelect],
  name: 'addCommunity',
  data () {
    let decoratorOptions = {
      community_name: {
        validateTrigger: 'blur',
        rules: [
          {required: true, message: '请输入小区名'},
          {pattern: this.REG.communityName, message: this.MESSAGE.communityName},
          {min: 2, max: 20, message: '小区名为2-20个字'}
        ]
      },
      areas: {
        rules: [{required: true, message: '请选择省市区'}]
      },
      property_id: {
        rules: [{required: true, message: '请选择物业'}]
      },
      map_lng: {
        validateTrigger: 'blur',
        rules: [{required: true, message: '输入经度'}]
      },
      map_lat: {
        validateTrigger: 'blur',
        rules: [{required: true, message: '输入纬度'}]
      },
      address: {
        rules: [
          {required: true, message: '请输入小区地址'},
          {min: 2, max: 50, message: '小区地址为2-50个字'}
        ]
      },
      telephone: {
        validateTrigger: 'blur',
        rules: [
          {required: true, message: '请输入管理处电话'},
          {pattern: this.REG.telephone, message: this.MESSAGE.telephone}
        ]
      },
      status: {initialValue: 1}
    };
    return {
      position: '',
      inputKey: {
        lng: 'map_lng',
        lat: 'map_lat',
        address: 'address'
      },
      formList: [
        {
          label: '小区名',
          inputType: 'input',
          options: [],
          placeholder: '请输入小区名',
          props: ['community_name', decoratorOptions.community_name]
        },
        {
          label: '所在区域',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择所在区域',
          handle: this.regionChange,
          props: ['areas', decoratorOptions.areas]
        },
        {
          label: '所属物业',
          inputType: 'select',
          options: [],
          placeholder: '请选择所属物业',
          props: ['property_id', decoratorOptions.property_id]
        },
        {
          slot: 'gps',
          label: 'GPS定位',
          inputType: 'input',
          subList: [
            {
              inputType: 'input',
              placeholder: '经度',
              props: ['map_lng', decoratorOptions.map_lng]
            },
            {
              inputType: 'input',
              placeholder: '纬度',
              props: ['map_lat', decoratorOptions.map_lat]
            }
          ]
        },
        {
          label: '小区地址',
          inputType: 'input',
          options: [],
          placeholder: '请输入小区地址',
          props: ['address', decoratorOptions.address]
        },
        {
          label: '管理处电话',
          inputType: 'input',
          options: [],
          placeholder: '请输入手机号或座机号',
          props: ['telephone', decoratorOptions.telephone]
        },
        {
          label: '状态',
          inputType: 'radioGroup',
          options: this.$store.state.statusList,
          placeholder: '',
          props: ['status', decoratorOptions.status]
        }
      ],
      formKey: {
        community_name: '',
        areas: '',
        property_id: '',
        map_lng: '',
        map_lat: '',
        address: '',
        telephone: '',
        status: ''
      },
      addParam: {
        url: '/community/add',
        reqHandle: '',
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/community/edit/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/community/',
        resHandle: this.resHandle
      }
    };
  },
  mounted () {
    this.getSelect();
  },
  methods: {
    regionChange (val, selected) {
      if (selected && selected.length) {
        let isCity = this.$store.state.citys.some(el => el === selected[0].label);
        if (isCity) { // 判断是否为直辖市
          this.position = selected[0].label;
        } else {
          this.position = selected[1].label;
        }
      }
    },
    /* 获取下拉 */
    getSelect () {
      this.regionSelect(1, 'formList', '1,2,3,4');
      this.propertySelect(2, 'formList');
    },
    resHandle (data) {
      if (data.area) {
        let area = data.area.split(' ');
        let isCity = this.$store.state.citys.some(el => el === area[0]);
        if (isCity) { // 判断是否为直辖市
          this.position = area[0];
        } else {
          this.position = area[1];
        }
      }

      let formValues = {};
      let arr = [];
      data.areas && data.areas.split(',').forEach((el) => {
        arr.push(parseInt(el));
      });
      formValues.areas = arr;
      return formValues;
    },
    reqHandle (param) {
      console.log('处理请求前数据: ', param);
      return param;
    },
    detailResHandle (res) {
      console.log('处理详情返回数据: ', res);
      return res;
    },
    editResHandle (res) {
      console.log('处理编辑返回数据: ', res);
      return res;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/baseData/community/addCommunity.vue